import { makeGlobalSideEffectHandler } from './make_global_use_effect';

const { Provider, useGlobalEffect: useBodyClass } = makeGlobalSideEffectHandler(
  (classes: string[]) => {
    document.body.className = classes.join(' ');
  }
);

export { Provider, useBodyClass };
